// Section.jsx
export const Section = ({ title, desc, children, actions }) => (
  <section className="set-section">
    <header className="set-section-head">
      <div>
        <h3 className="set-h3">{title}</h3>
        {desc && <p className="set-muted">{desc}</p>}
      </div>
      {actions && <div className="set-actions">{actions}</div>}
    </header>
    <div className="set-section-body">{children}</div>
  </section>
);
